import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/contents/patient-info/financing-options",
)({
  beforeLoad: () => {
    throw redirect({ to: "/cost-insurance" });
  },
});
